<template>
  <SkeletonLoader>
    <div class="ut-skeleton">
      <!-- Header -->
      <div class="sk-line sk-line--title" style="width: 35%; margin-bottom: 20px;"></div>

      <!-- Two-column filter section -->
      <div class="ut-skeleton__panels">
        <!-- Left panel: Filter Patients -->
        <div class="ut-skeleton__panel ut-skeleton__panel--wide">
          <div class="sk-line sk-line--title" style="width: 45%;"></div>
          <div class="ut-skeleton__filter-grid">
            <div v-for="f in filters" :key="f.id" class="ut-skeleton__filter-item">
              <div class="sk-line sk-line--sm" :style="{ width: f.labelWidth, marginBottom: '6px' }"></div>
              <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px;"></div>
            </div>
          </div>
          <div class="sk-rect" style="height: 36px; width: 120px; border-radius: 6px; margin-top: 12px;"></div>
        </div>

        <!-- Right panel: Your Lists -->
        <div class="ut-skeleton__panel">
          <div class="sk-line sk-line--title" style="width: 50%;"></div>
          <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px; margin-bottom: 12px;"></div>
          <div v-for="item in listItems" :key="item.id" style="margin-bottom: 8px;">
            <div class="sk-line" :style="{ width: item.width }"></div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="ut-skeleton__table">
        <div class="ut-skeleton__table-header">
          <div v-for="h in headers" :key="h.id" class="sk-rect" :class="{ 'ut-skeleton__hide-mobile': h.hideMobile }" :style="{ height: '14px', width: h.width }"></div>
        </div>
        <div v-for="r in 8" :key="'row-' + r" class="ut-skeleton__table-row">
          <div class="sk-line" :style="{ width: col1[r] }"></div>
          <div class="sk-line" :style="{ width: col2[r] }"></div>
          <div class="sk-line sk-line--sm ut-skeleton__hide-mobile" :style="{ width: col3[r] }"></div>
          <div class="sk-line ut-skeleton__hide-mobile" :style="{ width: col4[r] }"></div>
          <div class="sk-rect" style="height: 22px; width: 60px; border-radius: 12px;"></div>
          <div class="sk-line sk-line--sm ut-skeleton__hide-mobile" :style="{ width: col5[r] }"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'UnscheduledTreatmentSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      filters: [
        { id: 'date-range', labelWidth: '55%' },
        { id: 'codes', labelWidth: '40%' },
        { id: 'providers', labelWidth: '50%' },
        { id: 'procedures', labelWidth: '60%' },
      ],
      listItems: [
        { id: 'list-1', width: '60%' },
        { id: 'list-2', width: '70%' },
        { id: 'list-3', width: '50%' },
      ],
      headers: [
        { id: 'h-name', width: '15%', hideMobile: false },
        { id: 'h-procedure', width: '14%', hideMobile: false },
        { id: 'h-code', width: '10%', hideMobile: true },
        { id: 'h-provider', width: '16%', hideMobile: true },
        { id: 'h-status', width: '10%', hideMobile: false },
        { id: 'h-date', width: '12%', hideMobile: true },
      ],
      col1: { 1: '14%', 2: '11%', 3: '15%', 4: '12%', 5: '13%', 6: '10%', 7: '14%', 8: '11%' },
      col2: { 1: '12%', 2: '10%', 3: '13%', 4: '9%', 5: '11%', 6: '12%', 7: '10%', 8: '13%' },
      col3: { 1: '7%', 2: '9%', 3: '8%', 4: '6%', 5: '7%', 6: '9%', 7: '8%', 8: '7%' },
      col4: { 1: '16%', 2: '18%', 3: '15%', 4: '20%', 5: '17%', 6: '14%', 7: '19%', 8: '16%' },
      col5: { 1: '10%', 2: '8%', 3: '11%', 4: '9%', 5: '12%', 6: '10%', 7: '8%', 8: '11%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.ut-skeleton__panels {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.ut-skeleton__panel {
  flex: 1;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;

  &--wide {
    flex: 2;
  }
}

.ut-skeleton__filter-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 8px;
}

.ut-skeleton__table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.ut-skeleton__table-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.ut-skeleton__table-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

@media (max-width: 992px) {
  .ut-skeleton__panels {
    flex-direction: column;
  }

  .ut-skeleton__hide-mobile {
    display: none;
  }
}
</style>
